var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ei-header',{attrs:{"header2-show":true,"header2-lit":true}}),_c('ei-article-detail',{attrs:{"title":_vm.title,"time":_vm.time,"content":_vm.content}}),_c('ei-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }